import React from 'react'
import { patientLoad } from '../../../redux/actions/patient/patientActions'
import { change } from 'redux-form'
import { AutoComplete } from '../../../itrust_common/components/others'
import { connect } from 'react-redux'

function PatientSearch(props) {
  const { dispatch, handleAppointmentEditHandler, patientId, storeSpecificPatients, currentStoreId } = props

  const handlePatientLoad = (id) => {
    dispatch(patientLoad(id, { include: ['patient_medical_insurance', 'patient_vision_insurance'] }))
  }

  const handleSearchResult = (id) => {
    handlePatientLoad(id)
    handleAppointmentEditHandler({ formType: 'existing' })
    dispatch(change('appointmentForm', 'patient_id', id))
  }

  return (
    <>
      <AutoComplete
        fieldName="patient"
        placeholder="Search patient by Name"
        key={patientId}
        textField="name"
        valueField="id"
        onSelect={(id) => handleSearchResult(id)}
        additionalFilters={{ store_id: (storeSpecificPatients && currentStoreId) ? currentStoreId : '' }}
        klass="Patient"
        wrapperClasses="w-100 position-relative mb-5"
      />
    </>
  )
}

const mapStateToProps = state => {
  const { currentStore, organisation } = state

  return {
    storeSpecificPatients: organisation.organisation.preferences?.store_specific_patients,
    currentStoreId: currentStore.store.id,
  }
}

export default connect(mapStateToProps)(PatientSearch);
